import React, { useRef, useState } from "react"


export const SingleClickButton = ({ label="Click", onClick = function () {}, className="btn" }) => {
    
    const buttonRef = useRef(null);
      
    // wrapper to prevent double clicking
    const handleClick = e => {
        e.preventDefault()
        buttonRef.current.disabled = true;
        onClick && onClick()
    }

    return (
        <button className={className}
            ref={buttonRef}
            onClick={handleClick}
        >
            { label }
        </button>
    )
}
  
